import { runOnSportsWebInit } from '@frontend/sports/common/core/feature/app-init';

import { ExternalNativeAppService } from './external-native-app.service';

export const provideNativeApi = () => runOnSportsWebInit(ExternalNativeAppService);
